import React from "react";
import { ctaData } from "../../data/home";
import { mediaUrl } from "../../services/assetUrl";
import CtaLink from "./CtaLink";
import highlight from "./highlight";
import "./homeRedesign.css";

const sp = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.9, strokeLinecap: "round", strokeLinejoin: "round" };
const ICONS = {
  cap: (<svg {...sp}><path d="M22 10 12 5 2 10l10 5 10-5z" /><path d="M6 12v5c0 1 2.7 2 6 2s6-1 6-2v-5" /></svg>),
  calendar: (<svg {...sp}><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9.5h18M8 2.5v4M16 2.5v4" /></svg>),
  shield: (<svg {...sp}><path d="M12 3 4 6v6c0 4.5 3.2 7.8 8 9 4.8-1.2 8-4.5 8-9V6l-8-3Z" /><path d="m9 12 2 2 4-4" /></svg>),
  users: (<svg {...sp}><circle cx="9" cy="8" r="3.1" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0" /><path d="M16 6.2a3 3 0 0 1 0 5.6" /><path d="M17 14.4A5.5 5.5 0 0 1 20.5 19" /></svg>),
  rocket: (<svg {...sp}><path d="M5 15c-1.5 1-2 5-2 5s4-.5 5-2a2.1 2.1 0 0 0-3-3Z" /><path d="M9 14c5-2 9-7 9-11 0 0-6 0-11 5-2 2-2 4-2 4l4 4s2 0 4-2Z" /><circle cx="14.5" cy="8.5" r="1.4" /></svg>),
};
const ArrowIcon = (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>);
const ChatIcon = (<svg {...sp}><path d="M21 12a8 8 0 0 1-11.6 7.1L4 21l1.9-5.4A8 8 0 1 1 21 12Z" /><path d="M8.5 11h.01M12 11h.01M15.5 11h.01" /></svg>);

const DEFAULT_BANNER = "/images/home/admissions_banner.png";

// Admin-editable copy may contain the "{year}" token (e.g. "Admissions {year}",
// "{year} Intake"); the Admissions Year field in the Home Page Editor fills it in.
const withYear = (value, year) =>
  typeof value === "string" && year ? value.split("{year}").join(year) : value;

const CtaBand = ({ data }) => {
  const src = data || ctaData;
  const year = src.year || "";
  const fill = (value) => withYear(value, year);

  const eyebrow = fill(src.eyebrow);
  const heading = fill(src.heading);
  const subtitle = fill(src.subtitle);
  const primary = { ...(src.primary || {}), text: fill(src.primary?.text) };
  const secondary = { ...(src.secondary || {}), text: fill(src.secondary?.text) };
  const chips = (src.chips || []).map((c) => ({ ...c, title: fill(c.title), text: fill(c.text) }));
  const features = (src.features || []).map((f) => ({ ...f, title: fill(f.title), text: fill(f.text) }));
  const bannerStyle = { backgroundImage: `url("${mediaUrl(src.image || DEFAULT_BANNER)}")` };

  return (
    <section className="adm" aria-labelledby="adm-title">
      <div className="container">
        <div className="adm__banner" style={bannerStyle}>
          {/* left content */}
          <div className="adm__left">
            <span className="adm__eyebrow"><i aria-hidden="true" />{eyebrow}</span>
            <h2 id="adm-title" className="adm__title">{highlight(heading, src.highlight)}</h2>
            <p className="adm__sub">{subtitle}</p>
            <div className="adm__actions">
              <CtaLink to={primary.link} className="adm__btn adm__btn--primary">
                <span>{primary.text}</span>
                <span className="adm__btn-ic">{ArrowIcon}</span>
              </CtaLink>
              <CtaLink to={secondary.link} className="adm__btn adm__btn--ghost">
                <span className="adm__btn-chat">{ChatIcon}</span>
                <span>{secondary.text}</span>
              </CtaLink>
            </div>
          </div>

          {/* center floating chips */}
          {chips.map((c, i) => (
            <div className={`adm__chip adm__chip--${c.id || i} adm__chip--${c.tone}`} key={c.id || i} aria-hidden="true">
              <span className="adm__chip-ic">{ICONS[c.icon]}</span>
              <span className="adm__chip-txt"><strong>{c.title}</strong><small>{c.text}</small></span>
            </div>
          ))}

          {/* bottom feature card */}
          <div className="adm__features">
            {features.map((f, i) => (
              <div className="adm__feat" key={i}>
                <span className={`adm__feat-ic adm__feat-ic--${f.tone}`}>{ICONS[f.icon]}</span>
                <span className="adm__feat-txt"><strong>{f.title}</strong><small>{f.text}</small></span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
